export const formRow = [
  {
    span: 24,
    label: "上级组织",
    component: "ATreeSelect",
    placeholder: "请输入",
    prop: "parentId",
    list: [],
    allowClear: true,
  },
  {
    span: 24,
    label: "菜单名称",
    component: "AInput",
    placeholder: "请输入",
    prop: "menuName",
    allowClear: true,
    // sloteOptions: [{
    //   position: "top",
    //   title: "系统将优先使用您配置的名称",
    //   type: "tooltip",
    //   childOptions: {
    //     sloteType: "question-circle-o",
    //     style: "width: 50px; height: 50px",
    //   },
    // }],
    tooltip: {
      title: "系统将优先使用您配置的名称",
      type: "question-circle-o",
    },
  },
  {
    span: 24,
    label: "菜单英文名称",
    component: "AInput",
    placeholder: "请输入",
    prop: "englishName",
    allowClear: true,
  },
  {
    span: 24,
    label: "菜单顺序",
    component: "AInput",
    placeholder: "请输入",
    prop: "orderNum",
    allowClear: true,
  },
  {
    span: 24,
    label: "文章篇数",
    component: "AInput",
    placeholder: "请输入",
    prop: "limitNum",
    allowClear: true,
    disabled: false,
  },
  {
    span: 24,
    label: "状态",
    component: "ARadioGroup",
    prop: "status",
    allowClear: true,
    radioList: [
      {
        label: "开放",
        value: "0",
      },
      {
        label: "隐藏",
        value: "1",
      },
    ],
  },
  {
    span: 24,
    label: "菜单标识",
    component: "AInput",
    placeholder: "请输入",
    prop: "code",
    allowClear: true,
    disabled: false,
  },
];

export const formRules = {
  menuName: [
    {
      required: true,
      message: "请输入菜单名称",
      trigger: "change",
    },
  ],
  // englishName: [
  //   {
  //     required: true,
  //     message: "请输入菜单英文名称",
  //     trigger: "change",
  //   },
  // ],
};

export const hasEnglishName = ["xinxiServer", "zydh", "zxSummary", "home"];

export const aticalIndex = ["zxSummary", "hotProblem"];
